module.exports = __webpack_public_path__ + "media/images/contactese/sms-a68b4f6b17796de8bdbd189a5dc052c6.svg";